import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { StockTabIndex } from "features/creator/types";

type StockSegmentControlProps = {
  value: StockTabIndex;
  onChange: (tab: StockTabIndex) => void;
};

const SegmentButton = ({
  active,
  labelKey,
  iconName,
  onClick,
}: {
  active: boolean;
  labelKey: string;
  iconName: string;
  onClick: () => void;
}) => (
  <button
    className={`type-inherit-font flex-col-el flex-center gap-1 w-full h-[130px] px-2 py-2 rounded-2xl border-2 border-solid cursor-pointer transition-colors shadow-[0_3px_0_rgba(63,74,97,0.14),0_4px_10px_rgba(63,74,97,0.08)] active:translate-y-[2px] ${
      active
        ? "border-green-80 bg-green-60 text-textcolor-black"
        : "border-outline bg-white text-textcolor-black/60 hover:bg-green-40/20"
    }`}
    onClick={onClick}
  >
    <div className="flex-col-el flex-center w-[48px] h-[48px] shrink-0">
      <span className="material-symbols-outlined type-hero !leading-none">{iconName}</span>
    </div>
    <p className="type-text type-sm leading-tight whitespace-pre text-center">{I18n.t(labelKey)}</p>
  </button>
);

export const StockSegmentControl = ({ value, onChange }: StockSegmentControlProps) => {
  const play = usePlaySound();

  const handleClick = (tab: StockTabIndex) => () => {
    play();
    onChange(tab);
  };

  return (
    <div className="flex-col-el gap-3 w-full">
      <SegmentButton
        active={value === StockTabIndex.ALBUM}
        labelKey="MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"
        iconName="photo_library"
        onClick={handleClick(StockTabIndex.ALBUM)}
      />
      <SegmentButton
        active={value === StockTabIndex.DRAWING}
        labelKey="MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"
        iconName="edit_square"
        onClick={handleClick(StockTabIndex.DRAWING)}
      />
      <SegmentButton
        active={value === StockTabIndex.AI}
        labelKey="MSG_USER_STOCK_AI_TAB"
        iconName="auto_awesome"
        onClick={handleClick(StockTabIndex.AI)}
      />
    </div>
  );
};
